import React from 'react';
import { Container, Card, CardContent, Typography, Box } from '@mui/material';
import TopBar from '../components/TopBar';
import '../App.css';

const PrivacyPolicy = () => {
  return (
    <Container component="main" maxWidth="md">
      <TopBar />
      <Card sx={{ mt: 8, p: 3, mb: 4 }}>
        <CardContent>
          <Typography component="h1" variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
            Privacy Policy
          </Typography>
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            <b>Last updated: January 2025</b>
          </Typography>
          <Box sx={{ mt: 4 }}>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              At Clearance Scouts, accessible from https://clearancescounts.com, one of our main priorities is the privacy of our visitors. 
              This Privacy Policy document contains types of information that is collected and recorded by Clearance Scouts and how we use it.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Information We Collect
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              The personal information that you are asked to provide, and the reasons why you are asked to provide it, 
              will be made clear to you at the point we ask you to provide your personal information.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              If you contact us directly, we may receive additional information about you such as your name, email address, 
              phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              When you register for an Account, we may ask for your contact information, including items such as name, 
              email address, and location data.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              How We Use Your Information
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              We use the information we collect in various ways, including to:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 3 }}>
              <li><Typography variant="body1" sx={{ mb: 1 }}>Provide, operate, and maintain our website</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>Improve, personalize, and expand our website</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>Understand and analyze how you use our website</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>Develop new products, services, features, and functionality</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>Communicate with you, including for customer service and updates</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>Send you emails</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>Find and prevent fraud</Typography></li>
            </Box>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Log Files
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Clearance Scouts follows a standard procedure of using log files. These files log visitors when they visit websites. 
              All hosting companies do this and a part of hosting services' analytics. The information collected by log files 
              include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, 
              referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Cookies and Web Beacons
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Like any other website, Clearance Scouts uses 'cookies'. These cookies are used to store information including visitors' 
              preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize 
              the users' experience by customizing our web page content based on visitors' browser type and/or other information.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              GDPR Privacy Policy (Data Protection Rights)
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
              We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 3 }}>
              <li><Typography variant="body1" sx={{ mb: 1 }}>The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this service.</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>The right to erasure – You have the right to request that we erase your personal data, under certain conditions.</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>The right to restrict processing – You have the right to request that we restrict the processing of your personal data, under certain conditions.</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.</Typography></li>
              <li><Typography variant="body1" sx={{ mb: 1 }}>The right to data portability – You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</Typography></li>
            </Box>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Children's Information
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Another part of our priority is adding protection for children while using the internet. We encourage parents and 
              guardians to observe, participate in, and/or monitor and guide their online activity.
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Clearance Scouts does not knowingly collect any Personal Identifiable Information from children under the age of 13. 
              If you think that your child provided this kind of information on our website, we strongly encourage you to contact 
              us immediately and we will do our best efforts to promptly remove such information from our records.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Contact Us
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at BransonRideshare@gmail.com.
            </Typography>
          </Box>
          
          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider', textAlign: 'center' }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
              © 2025 Mark Forsythe. All Rights Reserved.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default PrivacyPolicy;